import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getRegulationsStagesPlanWorksQualitiControls(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS]
			.GET_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS,
		options
	)
}
function _getRegulationsStagesPlanWorksQualitiControlPreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS]
			.GET_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL_PREVIEW,
		options
	)
}
function _getRegulationsStagesPlanWorksQualitiControlPopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS]
			.GET_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL_POPUP,
		options
	)
}

function _createRegulationsStagesPlanWorksQualitiControl(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS]
			.CREATE_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL,
		options
	)
}

function _getRegulationsStagesPlanWorksQualitiControl(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS]
			.GET_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL,
		options
	)
}

function _patchRegulationsStagesPlanWorksQualitiControl(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS]
			.PATCH_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL,
		options
	)
}

function _putRegulationsStagesPlanWorksQualitiControl(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS]
			.PUT_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL,
		options
	)
}

function _deleteRegulationsStagesPlanWorksQualitiControl(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS]
			.DELETE_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS]
		.GET_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS]: _getRegulationsStagesPlanWorksQualitiControls,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS]
		.GET_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL_PREVIEW]: _getRegulationsStagesPlanWorksQualitiControlPreview,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS]
		.GET_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL_POPUP]: _getRegulationsStagesPlanWorksQualitiControlPopup,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS]
		.CREATE_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL]: _createRegulationsStagesPlanWorksQualitiControl,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS]
		.GET_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL]: _getRegulationsStagesPlanWorksQualitiControl,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS]
		.PATCH_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL]: _patchRegulationsStagesPlanWorksQualitiControl,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS]
		.PUT_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL]: _putRegulationsStagesPlanWorksQualitiControl,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS]
		.DELETE_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL]: _deleteRegulationsStagesPlanWorksQualitiControl,
}
